import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate, useNavigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import ArbitrageBot from "@/pages/bots/ArbitrageBot";
import PumpMigrationBot from "@/pages/bots/PumpMigrationBot";
import AITradeBot from "@/pages/bots/AITradeBot";
import AIComboBot from "@/pages/bots/AIComboBot";
import Tape from "@/pages/Tape";
import "@/App.css";

function ConditionalNavbar() {
  const loc = useLocation();
  if (loc.pathname.startsWith("/tape")) return null;
  return <Navbar />;
}

function SessionManager() {
  const navigate = useNavigate();
  
  useEffect(() => {
    const sessionTimer = setTimeout(() => {
      alert("Session expired. Redirecting to home to refresh feeds.");
      navigate("/");
      window.location.reload(); 
    }, 10 * 60 * 1000);

    return () => clearTimeout(sessionTimer);
  }, [navigate]);

  return null;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SessionManager />
        <ConditionalNavbar />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/bot/arbitrage" element={<ArbitrageBot />} />
          <Route path="/bot/pump-migration" element={<PumpMigrationBot />} />
          <Route path="/bot/ai-trade" element={<AITradeBot />} />
          <Route path="/bot/ai-combo" element={<AIComboBot />} />
          <Route path="/tape" element={<Tape />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0F1014",
              border: "1px solid rgba(0,229,255,0.3)",
              color: "#F3F4F6",
              fontFamily: "JetBrains Mono, monospace",
              borderRadius: 0,
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}
